/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockSupplierStatements
 */
angular.module('mercury.modules.stock.statement')
.factory('StockSupplierStatements', ["$resource", "settings", function($resource, settings) {
  var StockSupplierStatements = $resource(settings.apiHost + '/r/StockSupplierStatements/:id', {id: '@id'}, {
    update: {method: 'PUT'},
    patch: {method: 'PATCH'}
  });

  /**
   * Get all supplier statements between a period for a supplier
   *
   * @memberof StockSupplierStatements
   * @param  {String} startTime  start of period
   * @param  {String} endTime    end of period
   * @param  {String} supplierId supplier id
   */
  function getAll(startTime, endTime, supplierId) {
    var filter = 'DatestampStart lt ' + endTime +
        ' and DatestampEnd gt ' + startTime +
        ' and DatestampDeleted eq null ';

    if (supplierId) {
      filter += 'and SupplierId eq ' + supplierId;
    }

    return StockSupplierStatements.query({
      $filter: filter
    });
  }

  /**
   * Get a specified statement
   *
   * @memberof StockSupplierStatements
   * @param  {String} statementId Id of the statement
   */
  function get(statementId) {
    return StockSupplierStatements.get({id: statementId});
  }

  /**
   * Save a statement
   *
   * @memberof StockSupplierStatements
   * @param  {Object} statement New or updated statement model
   */
  function save(statement) {
    if (statement.id) {
      return StockSupplierStatements.update(statement).$promise;
    } else {
      return StockSupplierStatements.save(statement).$promise;
    }
  }

  /**
   * Set a statement as deleted
   *
   * @memberof StockSupplierStatements
   * @param  {Object} statement statement model
   */
  function remove(statement) {
    var copy = angular.copy(statement);
    copy.datestampDeleted = moment().format();

    return save(copy);
  }

  /**
   * Set the Xero Invoice Id of a statement to null
   *
   * @memberof StockSupplierStatements
   * @param  {Object} statement statement model
   */
  function unlinkFromXero(statement) {
    return StockSupplierStatements.patch({id: statement.id}, {xeroInvoiceId: null}).$promise;
  }

  return {
    getAll: getAll,
    get: get,
    save: save,
    remove: remove,
    unlinkFromXero: unlinkFromXero
  };
}]);
